"use client";

import * as S from "./styles.ts";
import { useState } from "react";
import TabLabels from "./TabLabels";
import TabContent from "./TabContent";
import useLink from "@/lib/helpers/useLink.ts";

type TTabKey = string | number;

export type TTab = {
  label: {
    value: string;
    startContent?: any;
    endContent?: any;
  };
  content?: any;
  key?: TTabKey;
  disabled?: boolean;
  href?: string;
};

export interface ITabsProps {
  tabs: TTab[];
  defaultSelected?: string | number;
  onTabChange?: (key: TTabKey) => void;
  selected?: string;
}

const Tabs = ({
  tabs = [],
  defaultSelected,
  onTabChange,
  selected,
}: ITabsProps) => {
  const link = useLink();
  const [activeTab, setActiveTab] = useState<TTabKey>(
    (defaultSelected as any) || (tabs[0]?.key as any)
  );
  const usedTab = selected || activeTab;

  const onChange = (tab: TTabKey) => {
    const foundTab = tabs.find((t) => t.key === tab);
    if (foundTab?.disabled) {
      return;
    }
    if (foundTab?.href) {
      link({
        href: foundTab.href,
      });
      return;
    }
    setActiveTab(tab);
    onTabChange && onTabChange(tab);
  };

  return (
    <S.TabsSectionWrapper>
      <S.TabsSectionContainer>
        <TabLabels
          tabs={tabs}
          activeTab={activeTab}
          onChange={onChange}
        />
        <TabContent>
          {tabs.find((tab) => tab.key === usedTab)?.content}
        </TabContent>
      </S.TabsSectionContainer>
    </S.TabsSectionWrapper>
  );
};

export default Tabs;
